import React from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { I18n as I } from 'react-redux-i18n';
import { isFunc, unaccent } from 'vdlib';
import { Col, Row, Input, Select, DatePicker, Collapse } from 'antd';
import moment from 'moment';
import 'moment/locale/el';

import { FilterOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const dateFormat = 'DD-MM-YYYY';
const { Option } = Select;
const filterStyle = { display: 'flex', marginBottom: 10 };
const ellipsisStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

// const stringFilterOption =
const filterOption = (input, option) => {
  const inputText = unaccent(input).toLowerCase();
  const optionText = unaccent(option.children).toLowerCase();
  return optionText.indexOf(inputText) >= 0;
};

const AuctionsListFilters = ({
  brands,
  filters,
  insurances,
  isExpert,
  isInsurance,
  isOperator,
  lang,
  location,
  regions,
  setFilter,
  vehicleTypes,
  columnDefsKey,
  auctionStatuses,
}) => {
  // returns a default filter if location filters correspond to location
  const extractFilter = React.useMemo(() => {
    const { Value: locationFilterValue } =
      filters.find(x => x.Name === 'forLocation') || {};
    const defaultValueFormatter = value => value || null;
    return locationFilterValue === location.pathname
      ? (name, valueFormatter) => {
          const { Value: filterValue } =
            filters.find(f => f.Name === name) || {};
          return isFunc(valueFormatter)
            ? valueFormatter(filterValue)
            : defaultValueFormatter(filterValue);
        }
      : () => null;
  }, [filters, location]);

  return (
    <Collapse
    // className="grid-filters-wrap clearfix mb pt row"
    >
      <Panel
        header={
          <div>
            <FilterOutlined
              style={{
                marginTop: 2,
                fontSize: 18,
                position: 'absolute',
                color: '#364150',
              }}
            />
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#364150',
                marginLeft: 25,
              }}
            >
              Filters
            </div>
          </div>
        }
        key="1"
      >
        <Row>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">ID</span>
            <Input
              style={{
                width: 200,
              }}
              onChange={e => setFilter('ID', e.target.value)}
              defaultValue={extractFilter('ID')}
            />
          </Col>
          {isInsurance || isOperator ? (
            <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
              <span className="gt-estimate-cell-span">{I.t('FOLDER_NO')}</span>
              <Input
                style={{
                  width: 200,
                }}
                onChange={e => setFilter('FolderNumber', e.target.value)}
                defaultValue={extractFilter('FolderNumber')}
              />
            </Col>
          ) : (
            false
          )}
          {isInsurance || isOperator ? (
            <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
              <span className="gt-estimate-cell-span">
                {I.t('PLATE_NUMBER')}
              </span>
              <Input
                style={{ width: 200 }}
                onChange={e => setFilter('PlateNumber', e.target.value)}
                defaultValue={extractFilter('PlateNumber')}
              />
            </Col>
          ) : (
            false
          )}
          {isOperator ? (
            <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
              <span className="gt-estimate-cell-span">{I.t('INSURANCE')}</span>
              <Select
                allowClear={true}
                showSearch
                style={{ width: 200 }}
                placeholder={`${I.t('DATAGRID_CHOOSE')} ${I.t('INSURANCE')}`}
                filterOption={filterOption}
                onChange={value => setFilter('InsuranceID', value)}
                defaultValue={extractFilter('InsuranceID')}
              >
                {insurances.map(x => (
                  <Option value={x.ID}>{x.Description}</Option>
                ))}
              </Select>
            </Col>
          ) : null}
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">{I.t('PREFECTURE')}</span>
            <Select
              allowClear={true}
              showSearch
              style={{ width: 200 }}
              placeholder={`${I.t('CHOOSE_PREFECTURE')}`}
              filterOption={filterOption}
              onChange={value => setFilter('RegionID', value)}
              defaultValue={extractFilter('RegionID')}
            >
              {regions.map(x => (
                <Option key={x.ID} value={x.ID}>
                  {x.Description}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">{I.t('BRAND')}</span>
            <Select
              allowClear={true}
              showSearch
              style={{ width: 200 }}
              placeholder={`${I.t('DATAGRID_CHOOSE')} ${I.t('BRAND')}`}
              onChange={value => setFilter('VehicleBrand', value)}
              defaultValue={extractFilter('VehicleBrand')}
            >
              {brands.map(x => (
                <Option value={x.Description}>{x.Description}</Option>
              ))}
            </Select>
          </Col>
          <Col
            xxl={6}
            xl={8}
            lg={12}
            xs={24}
            style={{
              display: 'flex',
              marginBottom: 10,
            }}
          >
            <span className="gt-estimate-cell-span">{I.t('MODEL')}</span>
            <Input
              style={{ width: 200 }}
              onChange={e => setFilter('VehicleModel', e.target.value)}
              defaultValue={extractFilter('VehicleModel')}
            />
          </Col>
          <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
            <span className="gt-estimate-cell-span">
              {I.t('VEHICLE_TYPE_SHORTENED')}
            </span>
            <Select
              allowClear={true}
              showSearch
              style={{ width: 200 }}
              placeholder={`${I.t('DATAGRID_CHOOSE')} ${I.t(
                'VEHICLE_TYPE_SHORTENED'
              )}`}
              onChange={value => setFilter('VehicleTypeID', value)}
              defaultValue={extractFilter('VehicleTypeID')}
            >
              {vehicleTypes.map(x => (
                <Option value={x.ID}>{x.Description}</Option>
              ))}
            </Select>
          </Col>
          {isOperator && columnDefsKey.indexOf(auctionStatuses.Pending) > -1 ? (
            <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
              <span className="gt-estimate-cell-span" style={ellipsisStyle}>
                {I.t('DATE_CREATION')}
              </span>
              <DatePicker
                placeholder={I.t('DATE_CREATION')}
                format="DD-MM-YYYY"
                style={{
                  width: 200,
                }}
                onChange={(date, dateString) =>
                  setFilter('CreatedDate', dateString)
                }
                defaultValue={
                  (extractFilter('CreatedDate'),
                  value => (value ? moment(value, dateFormat) : null))
                }
              />
            </Col>
          ) : null}
          {/* {columnDefsKey.indexOf(auctionStatuses.Pending) === -1 ? (
            <Col xxl={6} xl={8} lg={12} xs={24} style={filterStyle}>
              <span className="gt-estimate-cell-span">
                {I.t('DATE_OVERDUE')}
              </span>
              <DatePicker
                placeholder={I.t('DATE_OVERDUE')}
                format="DD-MM-YYYY"
                style={{
                  width: 200,
                }}
                onChange={(date, dateString) =>
                  setFilter('EndDate', dateString)
                }
                defaultValue={
                  (extractFilter('EndDate'),
                  value => (value ? moment(value, dateFormat) : null))
                }
              />
            </Col>
          ) : null} */}
        </Row>
      </Panel>
    </Collapse>
  );
};

const lookupPropType = arrayOf(
  shape({
    Code: string,
    Description: string,
    ID: number,
  })
);

AuctionsListFilters.propTypes = {
  brands: lookupPropType,
  filters: arrayOf(shape({ Name: string, Value: string })),
  insurances: lookupPropType,
  isExpert: bool,
  isInsurance: bool,
  isOperator: bool,
  lang: string,
  location: shape({ pathname: string }),
  regions: lookupPropType,
  setFilter: func,
  vehicleTypes: lookupPropType,
};

export default AuctionsListFilters;
